if (!customElements.get('bg-video-play')) {
  class BackgroundVideoPlay extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.video-section');
      this.button = this.querySelector('button');
      this.soundBtn = this.section.querySelector('.js-bg-video-sound');
      this.active = false;

      this.button.addEventListener('click', this.handlePlayClick.bind(this));
      if (this.soundBtn) this.soundBtn.addEventListener('click', this.handleSoundClick.bind(this));
    }

    /**
     * Returns the background video element (it may be injected later by deferred-media).
     * @returns {?HTMLVideoElement}
     */
    get video() {
      return this.section.querySelector('video-component video');
    }

    /**
     * Handles 'click' events on the play button: first click restarts the video with sound,
     * subsequent clicks toggle pause/play.
     * @param {Event} evt - Event object.
     */
    handlePlayClick(evt) {
      // Stop video.js's section click handler from resuming the video right after it's paused.
      evt.stopPropagation();

      const { video } = this;
      if (!video) return;

      if (!this.boundVideo) {
        this.boundVideo = video;
        video.addEventListener('play', this.update.bind(this));
        video.addEventListener('pause', this.update.bind(this));
        video.addEventListener('volumechange', this.update.bind(this));
      }

      if (this.active && !video.paused) {
        video.pause();
        return;
      }

      if (!this.active) {
        this.active = true;
        video.currentTime = 0;
        video.muted = false;
      }

      // Let the theme's video component resume it when scrolled back into view.
      const component = video.closest('video-component');
      if (component) component.pausedByUser = false;

      video.play().catch(() => {
        // Browser blocked playback with sound - fall back to muted playback.
        video.muted = true;
        video.play().catch(() => {});
      });

      this.update();
    }

    /**
     * Handles 'click' events on the sound button.
     * @param {Event} evt - Event object.
     */
    handleSoundClick(evt) {
      evt.stopPropagation();

      const { video } = this;
      if (!video) return;

      video.muted = !video.muted;
    }

    /**
     * Syncs the buttons with the video state.
     */
    update() {
      const { video } = this;
      if (!video) return;

      this.button.setAttribute('aria-pressed', this.active && !video.paused);

      if (!this.soundBtn) return;
      this.soundBtn.hidden = !this.active;
      this.soundBtn.dataset.muted = video.muted;
      this.soundBtn.setAttribute('aria-label', video.muted ? this.soundBtn.dataset.labelUnmute : this.soundBtn.dataset.labelMute);
    }
  }

  customElements.define('bg-video-play', BackgroundVideoPlay);
}
